import { render } from "./DocsWeb.vue?vue&type=template&id=6355f6de&bindings={\"renderToc\":\"data\",\"publicPath\":\"data\"}"
import script from "./DocsWeb.vue?vue&type=script&lang=js"
export * from "./DocsWeb.vue?vue&type=script&lang=js"
script.render = render

export default script